import injectSheet from 'react-jss';

import Line from './component';
import styles from './styles';

export default injectSheet(styles)(Line);
